import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HiringService } from '../../../pages/hiring/services/hiring.service';

@Component({
  selector: 'app-apply-job-modal',
  templateUrl: './apply-job-modal.component.html',
  styleUrls: ['./apply-job-modal.component.css']
})

export class ApplyJobModalComponent implements OnInit {
  @ViewChild('applyForm', { static: true }) applyForm: NgForm;
  @Input() data: any = {};
  @Input() sourceData: any = {};
  formData: any = {};
  personalInfoRequire: any = {};
  personalInfoRequireList: any[] = [];
  requireReqSourceOnJobReq: boolean = false;
  portalSettings: any = {};
  dateFormat: string;
  phoneMask: any;
  stateList: any[] = [];
  sourceList: any[] = [];
  sourceDisplay: any[] = [];
  alert: any;

  constructor(portalSettingsService: PortalSettingsService, private hiringService: HiringService, private utilityService: UtilityService, private router: Router, public activeModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.dateFormat = utilityService.getDateFormat().toUpperCase();
  }
  ngOnInit(): void {
    this.formData.Country = 'US';
    this.personalInfoRequire = { FirstName: false, LastName: false, Suffix: false, Email: false, Cell: false, Phone: false, Contact: false, Address1: false, Address2: false, City: false, State: false, Zip: false, Country: false, MidName: false };
    this.personalInfoRequireList = this.portalSettings.ATSSetRequireFieldsPersonal.ConfigValue != null ? this.portalSettings.ATSSetRequireFieldsPersonal.ConfigValue.split(',') : [];
    this.requireReqSourceOnJobReq = this.portalSettings.RequireReqSourceOnJobReq.ConfigValue == 1;
    if (this.personalInfoRequireList?.length > 0) {
      this.personalInfoRequireList.forEach((val: any) => {
        this.personalInfoRequire[val] = true;
      })
    }
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue ? this.portalSettings.PhoneMask.ConfigValue.replace(/9/g, '_') : "";
    this.getCountry();
    this.getState();
    this.getVistaOptions();
  }

  countryChange() {
    this.formData.State = null;
    this.formData.Zip = null;
    if (this.formData.Country != 'O') {
      this.formData.CountryOther = null;
      this.getState();
    }
  }

  containAt() {
    var count = 0;
    if (this.formData.Email != null) {
      for (var i = 0; i < this.formData.Email.length; i++) {
        if (this.formData.Email[i] == "@" && i != this.formData.Email.length - 1)
          count++;
      }
    }
    return count == 0 ? true : false;
  }

  checkContact(where: string) {
    if ((this.formData.Contact == "C" && this.formData.Cell != null && this.formData.Cell != '' && where == "C") ||
      this.formData.Contact == "P" && this.formData.Phone != null && this.formData.Phone != '' && where == "P")
      this.formData.Contact = null;
  }

  continueClicked() {
    var requestObj: any = {};
    requestObj.firstName = this.formData.FirstName;
    requestObj.lastName = this.formData.LastName;
    requestObj.suffix = this.formData.Suffix;
    requestObj.email = this.formData.Email;
    requestObj.onboardProfileID = this.data.OnboardProfileID;
    requestObj.reqID = this.data.ReqID;
    requestObj.phone = this.formData.Phone;
    requestObj.address1 = this.formData.Address1;
    requestObj.address2 = this.formData.Address2;
    requestObj.city = this.formData.City;
    requestObj.state = this.formData.State;
    requestObj.cell = this.formData.Cell;
    requestObj.zip = this.formData.Zip;
    requestObj.contact = this.formData.Contact;
    requestObj.contactSourceNotes = this.formData.ContactSourceNotes;
    requestObj.contactSource = this.formData.ContactSource;
    requestObj.country = this.formData.Country;
    requestObj.ignoreLogout = true;
    requestObj.midName = this.formData.MidName;
    requestObj.countryOther = this.formData.CountryOther;
    this.hiringService.beginOnboardingProcess(requestObj).then((response: any) => {
      if (response != null) {
        if (response.success) {
          if (this.sourceData?.source != null && response.resultList?.length > 0 && response.resultList[0].OnboardID != null) {
            this.hiringService.setJobTargetAttributes(response.resultList[0].OnboardID, this.sourceData.source, this.sourceData.jtochash, this.sourceData.jtocprof)
              .then((setJobTargetResponse: any) => {
                if (setJobTargetResponse != null) {
                  if (setJobTargetResponse.success) {
                    window.location.href = "/Careers/Tasks"; // this needs to be a page refresh, don't use angular routing here
                  }
                  else {
                    this.alert = { type: "danger", msg: setJobTargetResponse.error }
                  }
                }
              });
          }
          else {
            window.location.href = "/Careers/Tasks"; // this needs to be a page refresh, don't use angular routing here
          }
        }
        else {
          this.alert = { type: "danger", msg: response.errorMessage };
        }
      }
    });
  }

  updatePhoneAndZip(data: string, field: string) {
    switch (field) {
      case 'Cell':
        this.formData.Cell = data;
        break;
      case 'Phone':
        this.formData.Phone = data;
        break;
      case 'Zip':
        this.formData.Zip = data;
        break;
    }
  }

  cancelClicked = function () {
    this.activeModal.dismiss();
  }

  private getCountry() {
    var country = this.portalSettings.CountryDateCode.ConfigValue;
    switch (country.toUpperCase()) {
      case "US":
        this.formData.Country = "US";
        break;
      case "CAN":
      case "CA":
        this.formData.Country = "CA";
        break;
      case "AU":
        this.formData.Country = "AU";
        break;
    }
  }

  private getState() {
    this.hiringService.getDependentLookupByColumnName("State", this.formData.Country).then((response: any) => {
      if (response != null) {
        this.stateList = response;
      }
    });
  }

  private getVistaOptions() {
    var requestParam = "reqID=null&optionType=contactsource";
    this.hiringService.getVistaOptions(requestParam).then((response: any) => {
      if (response != null) {
        this.sourceList = response;
        response.forEach((val: any, key: any) => {
          this.sourceDisplay[val] = key;
        })
      }
    });
  }
}
